import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { SubscriptionBase } from 'app/base';
import { AccountService } from 'app/shared';
import { SystemService } from '../system.service';
import { ProfileService } from '../profile.service';
import { LayoutService } from '../layout.service';



const ORG_PATH_PATTERN = /([/\w]+)(\/organization\/(\d+)?)([/\w]*)/;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'd-flex flex-column h-100 mian-navigation'
  }
})
export class NavigationComponent extends SubscriptionBase implements OnInit {
  @Input() menu: Array<App.MenuItem>;

  profileInfo: any;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    public router: Router,
    public system: SystemService,
    public layoutService: LayoutService,
    public accountService: AccountService,
    public profileService: ProfileService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.router.events
        .pipe(
          filter((event): boolean => {
            return event instanceof NavigationEnd;
          })
        )
        .subscribe((): void => {
          this.changeDetector.markForCheck();
        })
    );
    this.subscription.add(
      this.profileService.profileInfo$.subscribe((data): void => {
        this.profileInfo = data;
      })
    );
  }
}
